import { responsiveVariables } from "../../utilities/props.js";
import "./textAlign.css";
const getTextAlignStyles = (value) => {
    if (!value)
        return null;
    return {
        variables: responsiveVariables("--rs-text-align", value),
    };
};
export default getTextAlignStyles;
